import {useCallback, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {number, object, string} from "yup";
import {useSignal} from "@preact/signals-react";
import {useAppToast, useValidatorSeeker} from "@ui-seeker/app";
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS, REPRICING_ROUTES} from "@constants";
import {ACTION_REPRICING} from "../../@constants";
import {disabledRepricing, repricingFormErrors} from "../../@signals";
import useRepricingFormData from "./useFormData";


const buildRuleSchema = needRepricing => object({
	name: string().required('Rule name is required'),
	priceRuleValue: number().required('Price Rule Value is required'),
	...needRepricing && { actionValue: number().required('Action Value is required') }
})


export default function useRepricingFormAction() {
	const { showToast } = useAppToast()
	const navigate = useNavigate()
	const { dataSend } = useRepricingFormData()

	const { isValid, errors } = useValidatorSeeker(dataSend, buildRuleSchema(!disabledRepricing.value && dataSend.action !== ACTION_REPRICING.MATCH))
	const isLoading = useSignal(false)

	useEffect(() => {
		repricingFormErrors.value = errors
	}, [JSON.stringify(errors)]);

	const handleSubmit = useCallback(() => {
		isLoading.value = true
		postSubmit(`${BACKEND_APIS.REPRICING}/insert`, dataSend).then(() => {
			showToast.success('Data saved')
			navigate(REPRICING_ROUTES.PATH)
		}).catch(() => {
			isLoading.value = false
			showToast.error()
		})
	}, [JSON.stringify(dataSend)])

	return {
		isValid,
		isLoading: isLoading.value,
		handleSubmit
	}
}